import React from 'react'
import OrganizationPage from './org-management/OrganizationPage'

export function Organizations() {
    return (
        <div className='row g-5 g-xxl-8'>
            <OrganizationPage />
        </div>
    )
}